import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import _ from 'lodash';
declare var moment:any;

import { QuotationService, LgMessageModel, LatestInfoModel, LgMessageInfoModel, MessageService} from '../../../services/index';

@Component({
    selector:'quotationMain',
    templateUrl: 'quotation-main.html'
})

export class QuotationMain implements OnInit{

    private lgMessageList:Array<LgMessageModel> = new Array<LgMessageModel>();
    private latestInfo:LatestInfoModel = new LatestInfoModel();
    private cntOfStusCdObj:Object;
    private page:number = 0;
	private totalPage = 1;
	private isLoading:boolean = false;


    constructor(
        private quotationService:QuotationService,
        private messageService:MessageService,
        private router: Router){}
    
    ngOnInit(){

        this.getMessage(this.page);

        this.quotationService.getCntOfStusCdFromCnsltn().subscribe(resp => {
                this.cntOfStusCdObj = resp.data;
            }
        );
    }

    getMessage(page:number){
        this.isLoading = true;
        this.messageService.getLgMessageInfoByImprtce({isImportance:1, page:page}).subscribe((resp:any) => {
            let lgMessageInfo = resp.data;
            if(!lgMessageInfo || !lgMessageInfo.lgMessagePage ) return;

            let countrys = {
                KR:9
            }

            let messageInfo = lgMessageInfo;
            
            if(messageInfo && messageInfo.latestInfo.lastLgMsgDate){
                messageInfo.latestInfo.lastLgMsgDate = moment(messageInfo.latestInfo.lastLgMsgDate, "YYYY/MM/DD HH:mm:ss").add(countrys['KR'], 'hour').format("YYYY/MM/DD HH:mm");
            }
            this.lgMessageList = this.lgMessageList.concat(messageInfo.lgMessagePage.dataLst);
            this.latestInfo = messageInfo.latestInfo;
            this.page = messageInfo.lgMessagePage.pageNo;
            this.totalPage = messageInfo.lgMessagePage.totalPages;
            this.isLoading = false;
        });

    }

    updateLgMsgStusCd(idx:number, stusCd:number){
        let countrys = {
            KR:9
        }
        
        this.lgMessageList[idx].stusCd = stusCd;
        if(this.lgMessageList[idx].prtLgMsg){
            this.lgMessageList[idx].prtLgMsg.stusCd = stusCd;
		}
        this.messageService.updateLgMsgStusCd(this.lgMessageList[idx]).subscribe((lgMessageInfo:LgMessageInfoModel)=>{

            if(lgMessageInfo.latestInfo.lastLgMsgDate){
                lgMessageInfo.latestInfo.lastLgMsgDate = moment(lgMessageInfo.latestInfo.lastLgMsgDate, "YYYY/MM/DD HH:mm:ss").add(countrys['KR'], 'hour').format("YYYY/MM/DD HH:mm");
            }

            this.latestInfo = lgMessageInfo.latestInfo;
        });
        if(stusCd == 99){
            this.lgMessageList.splice(idx, 1);	
            if(this.lgMessageList && this.lgMessageList.length < 10 && this.totalPage > this.page){
				if(!this.isLoading)this.getMessage(this.page+1);
			}	
        } else {
            let obj = null;
            if(this.lgMessageList[idx].mapValue){
                obj = JSON.parse(this.lgMessageList[idx].mapValue);
            }
            if(this.lgMessageList[idx].message.messageKind.indexOf('BNR') > -1){
                if(obj && obj['corpId']) this.router.navigate(['fwdr/promotion/', obj['corpId']]);
            }else if(this.lgMessageList[idx].message.messageKind.indexOf('CORP') > -1){
                if(obj && obj['corpId'])  this.router.navigate(['fwdr/setting/', obj['corpId']]);
            }else{
                this.router.navigate(['quotation/consult-detail/', this.lgMessageList[idx].reqNo]);
            }
		}
    }

    moveForwarder(){
        this.router.navigate(['/quotation/consult-list']);
    }

    moveShipper(){
        alert("현재 화주 페이지로 이동이 불가능합니다.");
        return false;
    }

    onScroll(event){
		if(event.srcElement.scrollHeight - 1000 * (this.page+1) < event.srcElement.scrollTop && !this.isLoading && this.page < this.totalPage){
			this.getMessage(this.page+1);
		}
	}
}




// WEBPACK FOOTER //
// ./src/app/containers/quotation/main/quotation-main.ts